'use strict';

var typography = require('../../../../../../../../_virtual/typography.cjs');

var hasRequiredTypography;

function requireTypography () {
	if (hasRequiredTypography) return typography.__exports;
	hasRequiredTypography = 1;

	const TYPOGRAPHY_TYPES = {
	    h1: "h1",
	    h2: "h2",
	    h3: "h3",
	    h4: "h4",
	    h5: "h5",
	    body: "body",
	    footnote: "footnote",
	    caption: "caption",
	    subcaption: "subcaption"
	};

	typography.__exports.TYPOGRAPHY_TYPES = TYPOGRAPHY_TYPES;
	
	return typography.__exports;
}

exports.__require = requireTypography;
//# sourceMappingURL=typography.cjs.map
